export const POLL_INTERVAL_MINUTES = 5;
